<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">

        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>

          <div class="col-md-10">
            <card-section-header
              title="Site Session Competencies"
              icon="fas fa-list"
              buttonLabel="EDIT"
              buttonIcon="fas fa-pen-to-square"
              [buttonDisabled]="!selectedSite"
              (buttonClick)="onEditCompetencies()">
            </card-section-header>

            <div class="ml-3 mb-4">
              <p class="font-info-blue mb-0">
                <i class="fas fa-info-circle"></i>
                These are required on all Site Sessions, but do not affect Work Order sessions
              </p>
            </div>

            <p-table [value]="requiredCompetencies" [autoLayout]="true">
              <ng-template pTemplate="header">
                <tr>
                  <th>Name</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-competency>
                <tr [pSelectableRow]="competency">
                  <td>{{competency.competencyTypeName}}</td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="1">No Competencies required</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
